import * as Models from './../commonModels';
import * as ContractModels from './../contract/contract';

export class CustomerDictionaryListModel extends Models.ResponseBase {
  Items: CustomerPreviewModel[];
}

export class CustomersUserListModel extends Models.ResponseBase {
  public CustomerId: number;
  public Items: UserListItem[];
}

export class CustomerPreviewModel {
  public CustomerId: number;
  public ParentId: number;
  public Name: string;
  public HasCustomPrice: boolean;
  public IsActive: boolean;
  public IsDisactiveContract: boolean;
  public IsDOTRequired: boolean;
  public Nip: string;
  public Address: string;
  public Phone: string;
  public AttachmentTypeId: number;
  public IsEInvoice: boolean;
  public IsActiveContract: boolean;
  public Guardian: string;
  public AttachmentType: string;
  public IsSubCompany: boolean;
  public HasSubCompany: boolean;
  public Contact: string;
  public Note: string;
  public AddedBy: string;
  public IsExternalCustomer: boolean;
  public InvoicePaymentDays: number;
  public IsNewCarAvailableByGarage: boolean;
  public IsALDTFA: boolean;

  Children: CustomerPreviewModel[];

  IsSelectedVirtual: boolean = false;
  IsExpandedVirtual: boolean = false;
  GuardianId: number;

  constructor() {
    this.CustomerId = null;
    this.Name = null;
    this.HasCustomPrice = null;
    this.IsActive = null;
    this.IsDisactiveContract = null;
    this.IsSelectedVirtual = false;
    this.IsExpandedVirtual = false;
  }
}

export class UserListItem {
  UserId: number;
  FirstName: string;
  LastName: string;
  Mail: string;
  IsSelected: boolean;

  constructor() {
    this.UserId = null;
    this.FirstName = null;
    this.LastName = null;
    this.Mail = null;
    this.IsSelected = false;
  }
}

export class CustomerListModel extends Models.ListBaseModel {
  Items: CustomerPreviewModel[];
}

export class CustomerSearchModel extends Models.SearchBaseModel {
  CustomerId: number;
  ParentCustomerId: number;
  GuardianId: number;
  IsActive?: boolean;
  IsEInvoice?: boolean;
  IsDisactiveContract?: boolean;
  GarageIds?: number[];
  Name?: string;
  Guardian?: string;
  Nip?: string;
  HasSubCompany?: boolean;
  HasContract?: boolean;
  HasOtherDocuments?: boolean;
  IsActiveContract?: boolean;
  HasSignedContract: boolean;
  IsExternalCustomer: boolean = false;
}


export class CustomerBuyerModel {
  public CustomerBuyerId: number;
  public Name: string;
  public Nip: string;
  public Address: string;
}

export class CustomerModel {
  public CustomerId: number;
  public ParentCustomerId: number;
  public CustomerBuyerId: number;
  public HasCustomerBuyer: boolean;
  public CustomerBuyer: CustomerBuyerModel;
  public GarageId: number;
  public Name: string;
  public Nip: string;
  public NipCountry: string;
  public Address: string;
  public Telephones: string;
  public IsActive: boolean;
  public GuardianId: number;
  public AttachmentTypeId: number;
  public AttachmentType: string;
  public InvoicePaymentDays: number;
  public AdditionalServicesMaxRelativeCost: number;
  public IsEnableAddGarageVisit: boolean;
  public IsDisactiveContract: boolean;
  public IsEInvoice: boolean;
  public InvoiceMails: string;
  public NeedRelocationApproval: boolean;
  public Phone: string;
  public IsSubCompany: boolean;
  public HasSubCompany: boolean;
  public Guardian: string;
  public Contact: string;
  public Note: string;
  public AddedBy: string;
  public AddDate: Date;
  public IsExternalCustomer: boolean;
  public IsDOTRequired: boolean;
  public ContractDaysToEnd: number;
  public IsNewContractOffert: boolean;
  public IsNewCarAvailableByGarage: boolean;

  public AgreementFile: string | ArrayBuffer;
  public AgreementFileName: string;
  public OtherFile: string | ArrayBuffer;
  public OtherFileName: string;

  public CurrentContract: ContractModels.ContractModel;
}

export class CustomerGarageModel {
  public CustomerId: number;
  public GarageId: number;
  public IsLinked: boolean;
  public Name: string;
  public Street: string;
  public City: string;
  public Telephone: string;
  public PostCode: string;
  public Mail: string;
}

export class CustomerServiceModel {
  public CustomerId: number;
  public ServiceId: number;
  public IsLinked: boolean;
  public Name: string;
}

export class CustomerServiceLinkAllModel {
  public CustomerId: number;
  public IsLinked: boolean;
}

export class APICustomerServiceRightsModel {
  public CustomerId: number;
  public IsLinked: boolean;
  public APIServiceId: number;
  public APIRightId: number;
}
